/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    AddBulkTicketSeats200,
    AddBulkTicketSeatsBodyBody,
    AddEditTicketSeatBodyBody,
    BatchSeatAssignmentBody,
    ClearTimeslotSeatAssignments200,
    GetAutoSeating200,
    GetAutoSeatingBody,
    GetFreeTicketSeatsParams,
    GetTicketSeatsParams,
    RequestStatusResponseResponse,
    SearchTicketSeatsByIdBody,
    TicketSeatCreateSuccessResponseResponse,
    TicketSeatSuccessResponseResponse,
    TicketSeatsSuccessResponseResponse,
    UpdateBulkTicketSeats200,
    UpdateBulkTicketSeatsBodyBody,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Add new ticket seat
 */
export const addTicketSeat = (
    showId: number,
    addEditTicketSeatBodyBody: AddEditTicketSeatBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<TicketSeatCreateSuccessResponseResponse>({
        url: `/shows/${showId}/seats`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: addEditTicketSeatBodyBody,
        signal,
    });
};

export const getAddTicketSeatMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addTicketSeat>>,
        TError,
        { showId: number; data: AddEditTicketSeatBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof addTicketSeat>>,
    TError,
    { showId: number; data: AddEditTicketSeatBodyBody },
    TContext
> => {
    const mutationKey = ['addTicketSeat'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof addTicketSeat>>,
        { showId: number; data: AddEditTicketSeatBodyBody }
    > = (props) => {
        const { showId, data } = props ?? {};

        return addTicketSeat(showId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type AddTicketSeatMutationResult = NonNullable<Awaited<ReturnType<typeof addTicketSeat>>>;
export type AddTicketSeatMutationBody = AddEditTicketSeatBodyBody;
export type AddTicketSeatMutationError = APIErrorResponseResponse;

/**
 * @summary Add new ticket seat
 */
export const useAddTicketSeat = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addTicketSeat>>,
        TError,
        { showId: number; data: AddEditTicketSeatBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof addTicketSeat>>,
    TError,
    { showId: number; data: AddEditTicketSeatBodyBody },
    TContext
> => {
    const mutationOptions = getAddTicketSeatMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get ticket seats matching the filters
 */
export const getTicketSeats = (
    showId: number,
    params?: GetTicketSeatsParams,
    signal?: AbortSignal,
) => {
    return customInstance<TicketSeatsSuccessResponseResponse>({
        url: `/shows/${showId}/seats`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetTicketSeatsQueryKey = (showId?: number, params?: GetTicketSeatsParams) => {
    return [`/shows/${showId}/seats`, ...(params ? [params] : [])] as const;
};

export const getGetTicketSeatsQueryOptions = <
    TData = Awaited<ReturnType<typeof getTicketSeats>>,
    TError = APIErrorResponseResponse,
>(
    showId: number,
    params?: GetTicketSeatsParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getTicketSeats>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetTicketSeatsQueryKey(showId, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTicketSeats>>> = ({ signal }) =>
        getTicketSeats(showId, params, signal);

    return { queryKey, queryFn, enabled: !!showId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getTicketSeats>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetTicketSeatsQueryResult = NonNullable<Awaited<ReturnType<typeof getTicketSeats>>>;
export type GetTicketSeatsQueryError = APIErrorResponseResponse;

/**
 * @summary Get ticket seats matching the filters
 */

export function useGetTicketSeats<
    TData = Awaited<ReturnType<typeof getTicketSeats>>,
    TError = APIErrorResponseResponse,
>(
    showId: number,
    params?: GetTicketSeatsParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getTicketSeats>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetTicketSeatsQueryOptions(showId, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Add new ticket seats in bulk
 */
export const addBulkTicketSeats = (
    addBulkTicketSeatsBodyBody: AddBulkTicketSeatsBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<AddBulkTicketSeats200>({
        url: `/shows/seatsbulk`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: addBulkTicketSeatsBodyBody,
        signal,
    });
};

export const getAddBulkTicketSeatsMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addBulkTicketSeats>>,
        TError,
        { data: AddBulkTicketSeatsBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof addBulkTicketSeats>>,
    TError,
    { data: AddBulkTicketSeatsBodyBody },
    TContext
> => {
    const mutationKey = ['addBulkTicketSeats'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof addBulkTicketSeats>>,
        { data: AddBulkTicketSeatsBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return addBulkTicketSeats(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type AddBulkTicketSeatsMutationResult = NonNullable<
    Awaited<ReturnType<typeof addBulkTicketSeats>>
>;
export type AddBulkTicketSeatsMutationBody = AddBulkTicketSeatsBodyBody;
export type AddBulkTicketSeatsMutationError = APIErrorResponseResponse;

/**
 * @summary Add new ticket seats in bulk
 */
export const useAddBulkTicketSeats = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addBulkTicketSeats>>,
        TError,
        { data: AddBulkTicketSeatsBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof addBulkTicketSeats>>,
    TError,
    { data: AddBulkTicketSeatsBodyBody },
    TContext
> => {
    const mutationOptions = getAddBulkTicketSeatsMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Update ticket seats in bulk
 */
export const updateBulkTicketSeats = (
    updateBulkTicketSeatsBodyBody: UpdateBulkTicketSeatsBodyBody,
) => {
    return customInstance<UpdateBulkTicketSeats200>({
        url: `/shows/seatsbulk`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: updateBulkTicketSeatsBodyBody,
    });
};

export const getUpdateBulkTicketSeatsMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof updateBulkTicketSeats>>,
        TError,
        { data: UpdateBulkTicketSeatsBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof updateBulkTicketSeats>>,
    TError,
    { data: UpdateBulkTicketSeatsBodyBody },
    TContext
> => {
    const mutationKey = ['updateBulkTicketSeats'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof updateBulkTicketSeats>>,
        { data: UpdateBulkTicketSeatsBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return updateBulkTicketSeats(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type UpdateBulkTicketSeatsMutationResult = NonNullable<
    Awaited<ReturnType<typeof updateBulkTicketSeats>>
>;
export type UpdateBulkTicketSeatsMutationBody = UpdateBulkTicketSeatsBodyBody;
export type UpdateBulkTicketSeatsMutationError = APIErrorResponseResponse;

/**
 * @summary Update ticket seats in bulk
 */
export const useUpdateBulkTicketSeats = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof updateBulkTicketSeats>>,
        TError,
        { data: UpdateBulkTicketSeatsBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof updateBulkTicketSeats>>,
    TError,
    { data: UpdateBulkTicketSeatsBodyBody },
    TContext
> => {
    const mutationOptions = getUpdateBulkTicketSeatsMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Search ticket seats by id list
 */
export const searchTicketSeatsById = (
    showId: number,
    searchTicketSeatsByIdBody: SearchTicketSeatsByIdBody,
    signal?: AbortSignal,
) => {
    return customInstance<TicketSeatsSuccessResponseResponse>({
        url: `/shows/${showId}/seats/search`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: searchTicketSeatsByIdBody,
        signal,
    });
};

export const getSearchTicketSeatsByIdMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof searchTicketSeatsById>>,
        TError,
        { showId: number; data: SearchTicketSeatsByIdBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof searchTicketSeatsById>>,
    TError,
    { showId: number; data: SearchTicketSeatsByIdBody },
    TContext
> => {
    const mutationKey = ['searchTicketSeatsById'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof searchTicketSeatsById>>,
        { showId: number; data: SearchTicketSeatsByIdBody }
    > = (props) => {
        const { showId, data } = props ?? {};

        return searchTicketSeatsById(showId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type SearchTicketSeatsByIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof searchTicketSeatsById>>
>;
export type SearchTicketSeatsByIdMutationBody = SearchTicketSeatsByIdBody;
export type SearchTicketSeatsByIdMutationError = APIErrorResponseResponse;

/**
 * @summary Search ticket seats by id list
 */
export const useSearchTicketSeatsById = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof searchTicketSeatsById>>,
        TError,
        { showId: number; data: SearchTicketSeatsByIdBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof searchTicketSeatsById>>,
    TError,
    { showId: number; data: SearchTicketSeatsByIdBody },
    TContext
> => {
    const mutationOptions = getSearchTicketSeatsByIdMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get free ticket seats matching the filters
 */
export const getFreeTicketSeats = (
    showId: number,
    params: GetFreeTicketSeatsParams,
    signal?: AbortSignal,
) => {
    return customInstance<TicketSeatsSuccessResponseResponse>({
        url: `/shows/${showId}/seatsfree`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetFreeTicketSeatsQueryKey = (
    showId?: number,
    params?: GetFreeTicketSeatsParams,
) => {
    return [`/shows/${showId}/seatsfree`, ...(params ? [params] : [])] as const;
};

export const getGetFreeTicketSeatsQueryOptions = <
    TData = Awaited<ReturnType<typeof getFreeTicketSeats>>,
    TError = APIErrorResponseResponse,
>(
    showId: number,
    params: GetFreeTicketSeatsParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getFreeTicketSeats>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetFreeTicketSeatsQueryKey(showId, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFreeTicketSeats>>> = ({ signal }) =>
        getFreeTicketSeats(showId, params, signal);

    return { queryKey, queryFn, enabled: !!showId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getFreeTicketSeats>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetFreeTicketSeatsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getFreeTicketSeats>>
>;
export type GetFreeTicketSeatsQueryError = APIErrorResponseResponse;

/**
 * @summary Get free ticket seats matching the filters
 */

export function useGetFreeTicketSeats<
    TData = Awaited<ReturnType<typeof getFreeTicketSeats>>,
    TError = APIErrorResponseResponse,
>(
    showId: number,
    params: GetFreeTicketSeatsParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getFreeTicketSeats>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetFreeTicketSeatsQueryOptions(showId, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get auto seating suggestions for given requirements
 */
export const getAutoSeating = (
    timeslotId: number,
    getAutoSeatingBody: GetAutoSeatingBody,
    signal?: AbortSignal,
) => {
    return customInstance<GetAutoSeating200>({
        url: `/timeslots/${timeslotId}/autoseating`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: getAutoSeatingBody,
        signal,
    });
};

export const getGetAutoSeatingMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof getAutoSeating>>,
        TError,
        { timeslotId: number; data: GetAutoSeatingBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof getAutoSeating>>,
    TError,
    { timeslotId: number; data: GetAutoSeatingBody },
    TContext
> => {
    const mutationKey = ['getAutoSeating'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof getAutoSeating>>,
        { timeslotId: number; data: GetAutoSeatingBody }
    > = (props) => {
        const { timeslotId, data } = props ?? {};

        return getAutoSeating(timeslotId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type GetAutoSeatingMutationResult = NonNullable<Awaited<ReturnType<typeof getAutoSeating>>>;
export type GetAutoSeatingMutationBody = GetAutoSeatingBody;
export type GetAutoSeatingMutationError = APIErrorResponseResponse;

/**
 * @summary Get auto seating suggestions for given requirements
 */
export const useGetAutoSeating = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof getAutoSeating>>,
        TError,
        { timeslotId: number; data: GetAutoSeatingBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof getAutoSeating>>,
    TError,
    { timeslotId: number; data: GetAutoSeatingBody },
    TContext
> => {
    const mutationOptions = getGetAutoSeatingMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Batch update seat assignments for a timeslot
 */
export const batchSeatAssignment = (
    timeslotId: number,
    batchSeatAssignmentBody: BatchSeatAssignmentBody,
) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/timeslots/${timeslotId}/seat-assignments`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: batchSeatAssignmentBody,
    });
};

export const getBatchSeatAssignmentMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof batchSeatAssignment>>,
        TError,
        { timeslotId: number; data: BatchSeatAssignmentBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof batchSeatAssignment>>,
    TError,
    { timeslotId: number; data: BatchSeatAssignmentBody },
    TContext
> => {
    const mutationKey = ['batchSeatAssignment'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof batchSeatAssignment>>,
        { timeslotId: number; data: BatchSeatAssignmentBody }
    > = (props) => {
        const { timeslotId, data } = props ?? {};

        return batchSeatAssignment(timeslotId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type BatchSeatAssignmentMutationResult = NonNullable<
    Awaited<ReturnType<typeof batchSeatAssignment>>
>;
export type BatchSeatAssignmentMutationBody = BatchSeatAssignmentBody;
export type BatchSeatAssignmentMutationError = APIErrorResponseResponse;

/**
 * @summary Batch update seat assignments for a timeslot
 */
export const useBatchSeatAssignment = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof batchSeatAssignment>>,
        TError,
        { timeslotId: number; data: BatchSeatAssignmentBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof batchSeatAssignment>>,
    TError,
    { timeslotId: number; data: BatchSeatAssignmentBody },
    TContext
> => {
    const mutationOptions = getBatchSeatAssignmentMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Clear every seat assignment for a timeslot
 */
export const clearTimeslotSeatAssignments = (timeslotId: number) => {
    return customInstance<ClearTimeslotSeatAssignments200>({
        url: `/timeslots/${timeslotId}/seat-assignments`,
        method: 'DELETE',
    });
};

export const getClearTimeslotSeatAssignmentsMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof clearTimeslotSeatAssignments>>,
        TError,
        { timeslotId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof clearTimeslotSeatAssignments>>,
    TError,
    { timeslotId: number },
    TContext
> => {
    const mutationKey = ['clearTimeslotSeatAssignments'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof clearTimeslotSeatAssignments>>,
        { timeslotId: number }
    > = (props) => {
        const { timeslotId } = props ?? {};

        return clearTimeslotSeatAssignments(timeslotId);
    };

    return { mutationFn, ...mutationOptions };
};

export type ClearTimeslotSeatAssignmentsMutationResult = NonNullable<
    Awaited<ReturnType<typeof clearTimeslotSeatAssignments>>
>;

export type ClearTimeslotSeatAssignmentsMutationError = APIErrorResponseResponse;

/**
 * @summary Clear every seat assignment for a timeslot
 */
export const useClearTimeslotSeatAssignments = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof clearTimeslotSeatAssignments>>,
        TError,
        { timeslotId: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof clearTimeslotSeatAssignments>>,
    TError,
    { timeslotId: number },
    TContext
> => {
    const mutationOptions = getClearTimeslotSeatAssignmentsMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get ticket seat by id
 */
export const getTicketSeat = (showId: number, id: number, signal?: AbortSignal) => {
    return customInstance<TicketSeatSuccessResponseResponse>({
        url: `/shows/${showId}/seats/${id}`,
        method: 'GET',
        signal,
    });
};

export const getGetTicketSeatQueryKey = (showId?: number, id?: number) => {
    return [`/shows/${showId}/seats/${id}`] as const;
};

export const getGetTicketSeatQueryOptions = <
    TData = Awaited<ReturnType<typeof getTicketSeat>>,
    TError = APIErrorResponseResponse,
>(
    showId: number,
    id: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getTicketSeat>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetTicketSeatQueryKey(showId, id);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTicketSeat>>> = ({ signal }) =>
        getTicketSeat(showId, id, signal);

    return { queryKey, queryFn, enabled: !!(showId && id), ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getTicketSeat>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetTicketSeatQueryResult = NonNullable<Awaited<ReturnType<typeof getTicketSeat>>>;
export type GetTicketSeatQueryError = APIErrorResponseResponse;

/**
 * @summary Get ticket seat by id
 */

export function useGetTicketSeat<
    TData = Awaited<ReturnType<typeof getTicketSeat>>,
    TError = APIErrorResponseResponse,
>(
    showId: number,
    id: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getTicketSeat>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetTicketSeatQueryOptions(showId, id, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Edit ticket seat
 */
export const editTicketSeat = (
    showId: number,
    id: number,
    addEditTicketSeatBodyBody: AddEditTicketSeatBodyBody,
) => {
    return customInstance<TicketSeatSuccessResponseResponse>({
        url: `/shows/${showId}/seats/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: addEditTicketSeatBodyBody,
    });
};

export const getEditTicketSeatMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editTicketSeat>>,
        TError,
        { showId: number; id: number; data: AddEditTicketSeatBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof editTicketSeat>>,
    TError,
    { showId: number; id: number; data: AddEditTicketSeatBodyBody },
    TContext
> => {
    const mutationKey = ['editTicketSeat'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof editTicketSeat>>,
        { showId: number; id: number; data: AddEditTicketSeatBodyBody }
    > = (props) => {
        const { showId, id, data } = props ?? {};

        return editTicketSeat(showId, id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type EditTicketSeatMutationResult = NonNullable<Awaited<ReturnType<typeof editTicketSeat>>>;
export type EditTicketSeatMutationBody = AddEditTicketSeatBodyBody;
export type EditTicketSeatMutationError = APIErrorResponseResponse;

/**
 * @summary Edit ticket seat
 */
export const useEditTicketSeat = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editTicketSeat>>,
        TError,
        { showId: number; id: number; data: AddEditTicketSeatBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof editTicketSeat>>,
    TError,
    { showId: number; id: number; data: AddEditTicketSeatBodyBody },
    TContext
> => {
    const mutationOptions = getEditTicketSeatMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Delete ticket seat by id
 */
export const deleteTicketSeat = (showId: number, id: number) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/shows/${showId}/seats/${id}`,
        method: 'DELETE',
    });
};

export const getDeleteTicketSeatMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteTicketSeat>>,
        TError,
        { showId: number; id: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteTicketSeat>>,
    TError,
    { showId: number; id: number },
    TContext
> => {
    const mutationKey = ['deleteTicketSeat'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteTicketSeat>>,
        { showId: number; id: number }
    > = (props) => {
        const { showId, id } = props ?? {};

        return deleteTicketSeat(showId, id);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteTicketSeatMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteTicketSeat>>
>;

export type DeleteTicketSeatMutationError = APIErrorResponseResponse;

/**
 * @summary Delete ticket seat by id
 */
export const useDeleteTicketSeat = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteTicketSeat>>,
        TError,
        { showId: number; id: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof deleteTicketSeat>>,
    TError,
    { showId: number; id: number },
    TContext
> => {
    const mutationOptions = getDeleteTicketSeatMutationOptions(options);

    return useMutation(mutationOptions);
};
